import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexLeaderboardCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      topTranscribers,
      currentContractor,
      weekStart,
      weekEnd,
    } = this.props;

    let transcribers = [];
    for (let transcriber of topTranscribers) {
      if (currentContractor.id === transcriber.id) {
        transcribers.push(
          <tr key={transcriber.id} className="leader-board-green-row">
            <td>{transcriber.name}</td>
            <td>{transcriber.min_with_good_rating.toFixed(1)}</td>
          </tr>
        );
      } else {
        transcribers.push(
          <tr key={transcriber.id}>
            <td>{transcriber.name}</td>
            <td>{transcriber.min_with_good_rating.toFixed(1)}</td>
          </tr>
        );
      }
    }

    return (
      <Card body>
        <h1 className="large">Last Week{"'"}s Leaderboard</h1>
        <p className="large">
          {weekStart} to {weekEnd}
        </p>
        <p>Congratulations to Our Top Transcribers!</p>
        <table className="table-bordered table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Minutes With Rating 4 or 5</th>
            </tr>
          </thead>
          <tbody>{transcribers}</tbody>
        </table>
      </Card>
    );
  }
}
